/* eslint-disable no-console */
// src/ota-updater.ts
/* eslint-disable no-console */
// import { App } from '@capacitor/app'
import { CapacitorUpdater } from '@capgo/capacitor-updater'

// let pending: BundleId | null = null
// let checking = false

// Version with update in background
// export function initOtaUpdater(versionUrl: string, zipUrl: string) {
//   if (!Capacitor.isNativePlatform()) return

//   async function check() {
//     if (checking) return
//     checking = true

//     try {
//       const remote = await fetch(versionUrl, { cache: 'no-store' }).then((r) => r.json())
//       const local = await CapacitorUpdater.current()

//       const remoteVer = String(remote?.version || '').trim()
//       const localVer = String(local?.bundle?.version || '').trim()

//       console.log('[OTA] Local:', localVer)
//       console.log('[OTA] Remote:', remoteVer)

//       if (!remoteVer || localVer === remoteVer) {
//         console.log('[OTA] Up-to-date')
//         return
//       }

//       console.log('[OTA] Downloading...')
//       pending = await CapacitorUpdater.download({
//         version: remoteVer,
//         url: zipUrl,
//       })
//       console.log('[OTA] Downloaded bundle:', pending)
//     } catch (e) {
//       console.warn('[OTA] Error:', e)
//     } finally {
//       checking = false
//     }
//   }

//   App.addListener('appStateChange', async ({ isActive }) => {
//     if (isActive) {
//       // SplashScreen.show()
//       await check()
//       // SplashScreen.hide()
//     } else if (!isActive && pending) {
//       SplashScreen.show()
//       try {
//         await CapacitorUpdater.set(pending)
//         console.log('[OTA] Update applied — app restarting...')
//       } catch (e) {
//         console.error('[OTA] Apply failed:', e)
//         SplashScreen.hide()
//       }
//       pending = null
//     }
//   })
// }

export async function initOtaUpdater(versionUrl: string, zipUrl: string) {
  // console.log('[OTA] Starting updater')

  try {
    // === SHOW BLOCKING SCREEN ===
    // await SplashScreen.show({ autoHide: false })

    const remote = await fetch(versionUrl, { cache: 'no-store' }).then((r) => r.json())
    const local = await CapacitorUpdater.current()

    const remoteVer = String(remote?.version || '').trim()
    const localVer = String(local?.bundle?.version || '').trim()
    const remoteZipUrl = typeof remote?.zipUrl === 'string' ? remote.zipUrl.trim() : ''
    const resolvedZipUrl = remoteZipUrl ? new URL(remoteZipUrl, versionUrl).toString() : zipUrl

    // console.log('[OTA] Local:', localVer)
    // console.log('[OTA] Remote:', remoteVer)

    if (!remoteVer || remoteVer === localVer) {
      // console.log('[OTA] Already up to date')
      return
    }

    // console.log('[OTA] Downloading update...')

    // === DOWNLOAD ===
    const bundle = await CapacitorUpdater.download({
      version: remoteVer,
      url: resolvedZipUrl,
    })

    // console.log('[OTA] Download complete:', bundle)

    // === APPLY UPDATE IMMEDIATELY ===
    // console.log('[OTA] Applying update...')
    await CapacitorUpdater.set(bundle)

    // App restarts automatically.
  } catch (err) {
    console.error('[OTA] Update failed:', err)
  } finally {
    // await SplashScreen.hide()
  }
}
